import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import Alert from "react-s-alert";
import { createStructuredSelector } from "reselect";
import {
  setData,
  numberLock,
  fetchNumbers,
  changeFormField
} from "ducks/actions";
import {
  makeSelectAvailableNumbers,
  makeSelectSilverNumbers,
  makeSelectGoldenNumbers,
  makeSelectSilverNumbersPrice,
  makeSelectGoldenNumbersPrice,
  makeSelectFormattedSelectedNumber,
  makeSelectSpecialNumberAllowed,
  makeSelectNewNumberForm,
  makeSelectPageValidations,
  makeSelectNumberSeries,
  makeSelectNumberLockError,
  makeSelectReferralCode,
  makeSelectPlanDetails
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import { forms } from "utils/constants";
import validate from "validations";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";
import { getPreSelectedNumber } from "utils/localStorage";

const NewNumberHOC = Component =>
  function Comp(props) {
    const {
      availableNumbers,
      fetchNumbers,
      setSelectedNumberTypeNew,
      selectNumber,
      formattedSelectedNumber,
      numberLockError,
      clearNumberLockError
    } = props;
    const preSelectedNumber = getPreSelectedNumber();
    const selectedNumber = formattedSelectedNumber?.number;
    useEffect(() => {
      clearNumberLockError();
      if (!isEmpty(preSelectedNumber) && isFunction(selectNumber)) {
        if (preSelectedNumber !== selectedNumber) {
          selectNumber(preSelectedNumber);
        }
      } else if (isEmpty(availableNumbers) && isFunction(fetchNumbers)) {
        fetchNumbers();
      }
      if (isFunction(setSelectedNumberTypeNew)) {
        setSelectedNumberTypeNew();
      }
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      if (
        !isEmpty(preSelectedNumber) &&
        isFunction(selectNumber) &&
        preSelectedNumber !== selectedNumber
      ) {
        selectNumber(preSelectedNumber);
      }
      // eslint-disable-next-line
    }, [preSelectedNumber]);

    useEffect(() => {
      if (!isEmpty(numberLockError)) {
        Alert.error(numberLockError);
      }
      // eslint-disable-next-line
    }, [numberLockError]);

    return <Component {...props} preSelectedNumber={preSelectedNumber} />;
  };

const mapStateToProps = createStructuredSelector({
  availableNumbers: makeSelectAvailableNumbers(),
  silverNumbers: makeSelectSilverNumbers(),
  goldenNumbers: makeSelectGoldenNumbers(),
  silverNumbersPrice: makeSelectSilverNumbersPrice(),
  goldenNumbersPrice: makeSelectGoldenNumbersPrice(),
  formattedSelectedNumber: makeSelectFormattedSelectedNumber(),
  specialNumberAllowed: makeSelectSpecialNumberAllowed(),
  planDetails: makeSelectPlanDetails(),
  formValues: makeSelectNewNumberForm(),
  formValidations: makeSelectPageValidations(forms.NEW_NUMBER_FORM),
  numberSeries: makeSelectNumberSeries(),
  numberLockError: makeSelectNumberLockError(),
  referralCode: makeSelectReferralCode()
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  portInOnlyMode: get(stateProps, "referralCode.port_in_only"),
  messageData: {
    referralCode: get(stateProps, "referralCode.value")
  }
});

export const mapDispatchToProps = dispatch => {
  return {
    fetchNumbers: callback => dispatch(fetchNumbers(callback)),
    selectNumber: number => {
      dispatch(setData({ key: "numbers", data: { error: null } }));
      dispatch(numberLock({ number }));
    },
    clearNumberLockError: () => {
      dispatch(setData({ key: "numbers", data: { error: null } }));
    },
    setSelectedNumberTypeNew: () => {
      dispatch(
        setData({ key: "selectedNumberType", data: { isPortIn: false } })
      );
      dispatch(
        changeFormField({
          form: forms.PRE_CHECKOUT_FORM,
          field: "number_type",
          value: "new_number"
        })
      );
    },
    onSubmit: (navigate, payload) => {
      dispatch(
        setData({ key: "selectedNumberType", data: { isPortIn: false } })
      );
      navigate();
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.NEW_NUMBER_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(NewNumberHOC(SmartRender));
